<div class="answer-option">
<section class="check-option col-50">
    <mat-checkbox class="check-select" [value]="item.key" *ngFor="let item of values" [checked]="getIsSelected(item.key)" (change)="onOptionChange($event, item.key)">{{item.value}}</mat-checkbox>
</section>
<div class="col-50-input">
    <app-selectinput *ngIf="checkedArr.indexOf('other') !== -1" placeholder="" [indexValue]="indexValue" [itemValue]="itemValueInput" (action)="onAction($event)"></app-selectinput>
</div>
</div>